import { QueryKey } from 'constants/reactQuery';

export const profileQueryKey = {
  profiles: [QueryKey.Profile] as const,
  profile: (id: number) => [...profileQueryKey.profiles, id] as const,
  profileIds: (ids: number[]) => [...profileQueryKey.profiles, ...ids] as const,
};
